<template>
	<section>
        <!--div style="width: 100%;"-->
        <el-col :span="24" class="toolbar">
            <!--el-row :gutter="20">
                <el-col :span="24" style="text-align: center; height:40px; line-height:40px">请选择区域:-->
            <div style="height: 40px; line-height: 40px">
                <el-select v-model="domain" filterable placeholder="请选择区域">
                    <el-option
                            v-for="item in serverItems"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <!--/el-col>
        </el-row-->
        </el-col>
        <template>
            <el-table :data="currentDeviceData" stripe style="width: 100%; margin-top: 20px" @row-click="handleDetails">
                <div v-for="(item,index) in tabInformation" :key="index">
                    <el-table-column :prop="item.prop" :label="item.label" :width="item.width"></el-table-column>
                </div>
                <el-table-column prop="Action" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" icon="el-icon-info" v-show="seen()" @click="handleDetails(scope.row)"></el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete" v-show="seen()" @click="handleDelete(scope.$index, scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 当前设备:{{$route.name}} -->
        </template>
        <!--分页-->
        <el-col :span="24" class="toolbar" style="padding-bottom:10px;">
            <el-pagination :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper" :total="deviceCount"
                           v-on:current-change="pageIndexChange" v-on:size-change="sizeChange">
            </el-pagination>
        </el-col>
        <!-- 详情界面 -->
        <el-dialog size="tiny" :title="showDetailsTitle" v-model="dialogTableVisible" :visible.sync="dialogTableVisible" :close-on-click-modal="false">
            <el-form :model="deviceDetails" label-width="110px" ref="areaForm" >
                <el-form-item label="UUID:" prop="UUID">
                    <el-input class="dialog_input" v-model="deviceDetails.uuid" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="DeviceId:" prop="DeviceId">
                    <el-input class="dialog_input" v-model="deviceDetails.device_id" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="TvName:" prop="TvName">
                    <el-input class="dialog_input" v-model="deviceDetails.tv_name" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="ClientType:" prop="ClientType">
                    <el-input class="dialog_input" v-model="deviceDetails.client_type" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="CreateTime:" prop="CreateTime">
                    <el-input class="dialog_input" v-model="deviceDetails.createTime" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="Country:" prop="Country">
                    <el-input class="dialog_input" v-model="deviceDetails.country" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="SwVersion:" prop="SwVersion">
                    <el-input class="dialog_input" v-model="deviceDetails.sw_version" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="Tokens:" prop="Tokens">
                    <el-input type="textarea" :rows="6" class="dialog_input" v-model="deviceDetails.tokens" :disabled="true"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click.native="closeEdit('areaForm')" >确定</el-button>
            </div>
        </el-dialog>
        <!--/div-->
	</section>
</template>

<script>

import { Config } from "@/config/config"
import { Country_list } from "@/locale/country_list"
import { mapState } from 'vuex'
import { deleteDevice, getDevices } from "../../api/device"
import Notify from '../../api/notifyMsg'

//var tableData = []
//var jsonObj
export default {
    name: 'Device',
    computed: mapState({
        user: state => state.user
    }),
    components: {
        
    },
    props: ['message'],
    data() {
        return {
            tabInformation: [
                // {
                // 	prop: 'activate_code_generate_time',
                // 	label: '激活码生成时间',
                // 	width: '200'
                // },
                {
                    prop: 'tv_name',
                    label: 'TvName',
                    width: '100'
                },
                {
                    prop: 'device_id',
                    label: 'DeviceId',
                    width: '350'
                },
                {
                    prop: 'uuid',
                    label: 'UUID',
                    width: '320'
                },
                {
                    prop: 'country',
                    label: 'Country',
                    width: '80'
                },

            ],
            currentDeviceData: [],
            tableData: [],
            domain: '',
            serverItems: [],
            dialogTableVisible: false,
            showDetailsTitle: '设备详情',
            deviceDetails: {
                uuid: '',
                device_id: '',
                tv_name: '',
                client_type: '',
                country: '',
                city: '',
                sw_version: '',
                tokens: '',
                createTime: '',
            },

            pageIndex: 1,
            pageSizes: [10, 20, 30, 40, 50],
            pageSize: 10,
            deviceCount: 0
        }
    },
    created: function() {
        this.getDomainData()
        this.message = ''
    },
    mounted() {
        console.log("aaaaaaaaaaa")
        this.domain = "EU";
        //this.getDeviceData()
    },
    watch: {
        /*'message' (newVal, oldVal) { //监听区域改变
            console.log("message on watch:", this.message)
            this.getDeviceData()
        },*/
        'domain' (newVal, oldVal) { //监听区域改变
            console.log("domain on watch:", this.message)
            this.message = newVal
            this.resetPageInfo()
            this.getDeviceData()
        }
        // '$route' (to, from) { //监听路由改变
        // 	domain = to.path.substring(9)
        // 	this.getDeviceData()
        // }
        // 'domain' (newVal, oldVal) { //监听路由改变
        // 	this.getDeviceData()
        // }
    },
    methods: {
        seen() {
            if(this.user.Role !== "admin") {
                return false;
            } else {
                return true;
            }
        },
        showDevice(device_id, client_type, country, tv_name, uuid, sw_version, city, tokens,createTime) {
            //this.activate_code_generate_time = activate_code_generate_time;
            this.device_id = device_id;
            this.client_type = client_type;
            this.country = country;
            this.tv_name = tv_name;
            this.uuid = uuid;
            this.sw_version = sw_version;
            this.city = city;
            this.tokens = tokens;
            this.createTime = createTime;
        },
        handleDetails(row, event, column) {
            var _this = this;
            console.log(row)
            if(column !== undefined && column.property === "Action") {
                return;
            }

            _this.deviceDetails.uuid = row.uuid;
            _this.deviceDetails.device_id = row.device_id;
            _this.deviceDetails.client_type = row.client_type;
            _this.deviceDetails.tv_name = row.tv_name;
            _this.deviceDetails.country = row.country;
            _this.deviceDetails.city = row.city;
            _this.deviceDetails.sw_version = row.sw_version;
            _this.deviceDetails.tokens = row.tokens;
            _this.deviceDetails.createTime = row.createTime;

            this.dialogTableVisible = true
        },
        closeEdit() {
            this.dialogTableVisible = false
        },
        handleDelete(index, row) {
            console.log(index, row);
            var _this = this
            this.$confirm('此操作将永久删除该设备, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    _this.deleteDev(row.uuid, _this.user.token)
                }).catch(() => {
                    this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        pageIndexChange(pageIndex) {
            console.log("pageIndexChange ", pageIndex)
            var _this = this
            _this.pageIndex = pageIndex
            _this.getDeviceData()
        },
        sizeChange(pageSize) {
            var _this = this
            _this.pageSize = pageSize
            _this.getDeviceData()
        },
        pagination() {
            console.log("pagination ");
            this.getDeviceData()
        },
        resetPageInfo() {
            var _this = this;
            _this.pageIndex = 1
        },
        getDeviceData() {
            console.log("url:"+this.message);
            var _this = this
            _this.currentDeviceData = [];
            //_this.deviceCount = 0;
            var offset = (_this.pageIndex - 1) * _this.pageSize;
            fetch(Config.url + "/api/v1/console/devices?domain=" + this.message + "&offset=" + offset + "&limit=" + _this.pageSize + "&token=" + _this.user.token)
            .then(response => response.json())
            .then(json => {
                console.log(json)
                if (json.Error_code === 1000) {
                    var i;
                    for (i = 0; i <= json.devices.length - 1; i++) {
                        //var activate_code_generate_time = json.devices[i].activate_code_generate_time
                        var device_id = json.devices[i].device_id;
                        var client_type = json.devices[i].client_type;
                        var country = Country_list[parseInt(json.devices[i].country)][1];
                        var tv_name = json.devices[i].tv_name;
                        var uuid = json.devices[i].uuid;
                        var timestamp = json.devices[i].create_time;
                        var newDate = new Date();
                        newDate.setTime(timestamp * 1000);
                        var createTime = newDate.toGMTString();
                        //console.log("creatatime:" + json.devices[i].createTime + " format:" + createTime);
                        var city = json.devices[i].city;
                        var sw_version = json.devices[i].software_version;
                        var tokens = "";
                        if (json.devices[i].tokens !== null && json.devices[i].tokens.length > 0) {
                            tokens = "device_access_token:" + json.devices[i].tokens[0].device_access_token + "\n "
                                + "expires_in:" + json.devices[i].tokens[0].expires_in + "\n"
                                + "refresh_token:" + json.devices[i].tokens[0].refresh_token + "\n"
                                + "create_time:" + json.devices[i].tokens[0].create_time + "\n"
                                + "client_id:" + json.devices[i].tokens[0].client_id;
                        }
                        //this.tableData[i] = new this.showDevice(/*activate_code_generate_time,*/ device_id, client_type, country, tv_name)
                        //this.currentDeviceData[i] = new this.showDevice(/*activate_code_generate_time,*/ device_id, client_type, country, tv_name)
                        _this.$set(_this.currentDeviceData, i, new _this.showDevice(device_id, client_type, country, tv_name, uuid,sw_version, city, tokens, createTime));
                    }
                    _this.deviceCount = json.device_count
                } else {
                    Notify.errMsgNotify(json.Error_code, _this)
                    return
                }
            })
        },
        deleteDev(uuid, token) {
            var _this = this;
            var query = "?uuid=" + uuid + "&domain=" + _this.message + "&token=" + _this.user.token;
            console.log(query);
            deleteDevice(query)
                .then(response => {
                    console.log(response)
                    if (response.data.Error_code === 1000) {
                        _this.$message({
                            type: 'success',
                            message: '删除成功！'
                        });
                        _this.currentDeviceData = [];
                        _this.getDeviceData();
                    } else {
                        /*_this.$message({
                            type: 'fail',
                            message: '删除失败，请重试。'
                        })*/
                        Notify.errMsgNotify(response.data.Error_code, _this)
                    }
            })
        },
        resolveData() {
            this.currentTableData = []
            var startIndex = (this.pageIndex - 1) * this.pageSize
            var currentPageMaxItemsSize = ((startIndex + this.pageSize) > (this.deviceCount - startIndex)) ? (this.deviceCount - startIndex) : (startIndex + this.pageSize)
            for (var a = startIndex, b = 0; a < currentPageMaxItemsSize + startIndex, b < currentPageMaxItemsSize; a++, b++) {
                console.log("a:" + a + " b:" + b + "  " + this.tableData[a])
                this.currentTableData[b] = this.tableData[a]
            }
            console.log(this.currentDeviceData)
        },
        getDomainData() {
            var _this = this
            this.$nextTick(function () {
                fetch(Config.url + "/api/v1/console/domains?token=" + _this.user.token)
                    .then(res => res.json())
                    .then(json => {
                        console.log("getDomainData json:", json);
                        if (json.Error_code === 1000) {
                            //var result = '{\"version_number\":1,\"domains\":[\"AS\",\"EU\",\"NA\"]}';
                            //var json = JSON.parse(result);
                            var i;
                            console.log(json.domains)
                            for (i = 0; i <= json.domains.length - 1; i++) {
                                var label = json.domains[i]
                                var value = json.domains[i]
                                _this.$set(_this.serverItems, i, new _this.showServerItems(label, value));
                            }
                        } else {
                            Notify.errMsgNotify(json.Error_code, _this)
                        }
                    })
            })
        },
        showServerItems(label, value) {
            this.label = label;
            this.value = value;
        }
    }
}
</script>

<style scoped>

/* .toolbar {
    float: left;
}
.name {
    width: 45%;
}
.value {
    width: 55%;
} */
.dialog_input {
    width: 87%;
}

</style>


// WEBPACK FOOTER //
// src/components/device/Device.vue